/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Alerts/Question': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M16 25c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9m0-20C9.935 5 5 9.935 5 16s4.935 11 11 11 11-4.935 11-11S22.065 5 16 5m-.405 13.787c.658 0 1.163.532 1.163 1.148 0 .617-.505 1.15-1.163 1.15a1.157 1.157 0 0 1-1.163-1.15c0-.616.505-1.148 1.163-1.148zm-.91-1.037c0-.952.364-1.429 1.05-2.17.686-.73.94-1.052.94-1.612 0-.49-.338-.91-1.066-.91-.546 0-1.023.294-1.289.56-.07.07-.14.056-.182-.028l-.7-1.569c-.028-.084-.014-.14.042-.196.294-.252 1.01-.77 2.2-.77 2.184 0 3.04 1.484 3.04 2.76 0 1.092-.505 1.736-1.318 2.633-.63.7-.883 1.035-.883 1.498v.042c0 .084-.042.14-.14.14h-1.555c-.098 0-.14-.056-.14-.14v-.238z"/>'
  }
})
